jQuery(document).ready(function($) {
    const $sidebar = $('.leadership-sidebar');
    const $body = $('body');

    // Guard clause
    if ($sidebar.length === 0) {
        return;
    }

    // Focus trap variables
    let focusableElements;
    let firstFocusable;
    let lastFocusable;
    let previouslyFocused;

    // Open bio sidebar (click and keyboard Enter)
    $(document).on('click keydown', '.js-open-bio', function(e) {
        // For keydown, only respond to Enter key
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }
        e.preventDefault();

        // Store previous focus
        previouslyFocused = this;

        // Get data from trigger (either card or button)
        let $trigger = $(this);
        if (!$trigger.data('post-id')) {
            $trigger = $(this).closest('[data-post-id]');
        }

        const name = $trigger.data('name') || '';
        const title = $trigger.data('title') || '';
        const blurb = $trigger.data('blurb') || '';
        const bio = $trigger.data('bio') || '';
        const image = $trigger.data('image') || '';
        const pictureDownload = $trigger.data('picture-download') || '';
        const bioDownload = $trigger.data('bio-download') || '';

        // Check if triggered from In Memoriam section
        const isMemoriam = $(this).closest('.leadership-memoriam').length > 0;
        if (isMemoriam) {
            $sidebar.addClass('is-memoriam');
        } else {
            $sidebar.removeClass('is-memoriam');
        }

        // Populate sidebar content
        $sidebar.find('.leadership-sidebar__name').text(name);
        $sidebar.find('.leadership-sidebar__title').text(title);
        $sidebar.find('.leadership-sidebar__blurb').html(blurb);
        $sidebar.find('.leadership-sidebar__bio').html(bio);

        // Set image
        if (image) {
            $sidebar.find('.leadership-sidebar__image-wrapper').html(
                '<img src="' + image + '" alt="' + name + '">'
            );
        } else {
            $sidebar.find('.leadership-sidebar__image-wrapper').empty();
        }

        // Build download buttons with SVG icons
        let downloadsHtml = '';

        if (pictureDownload) {
            downloadsHtml += '<a href="' + pictureDownload + '" download class="button button--light">';
            downloadsHtml += '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">';
            downloadsHtml += '<path d="M17.2,1.25 C19.4509614,1.25 19.9860556,1.29371942 20.7024862,1.6587217 C21.4081043,2.01824321 21.9817531,2.59192118 22.3412455,3.29751875 C22.7062762,4.01388313 22.75,4.54900457 22.75,6.8 L22.75,17.2 C22.75,19.4509681 22.7062776,19.986066 22.3412679,20.7024674 C21.9817594,21.4081091 21.4081091,21.9817594 20.7028241,22.341086 C20.54963,22.419238 20.3888724,22.4833073 20.2172434,22.5352477 C19.5931408,22.7243635 19.0857591,22.75 17.2,22.75 L6.8,22.75 C4.91423102,22.75 4.40685945,22.7243638 3.78251445,22.5351683 L3.61466904,22.4792003 C3.50486666,22.4390519 3.39945629,22.393249 3.29755782,22.3412654 C2.59192118,21.9817531 2.01824321,21.4081043 1.65871103,20.7024652 C1.29371942,19.9860556 1.25,19.4509614 1.25,17.2 L1.25,6.8 C1.25,4.54901128 1.29372079,4.01389353 1.65872414,3.29753902 C2.01824943,2.59192595 2.59192595,2.01824943 3.29753528,1.65872605 C4.01389353,1.29372079 4.54901128,1.25 6.8,1.25 L17.2,1.25 Z M15.3746802,17.7504977 L8.62532433,17.7504977 C7.83442896,17.7529797 7.6004271,17.7658245 7.36594606,17.8124913 C6.07672664,18.0689117 5.06889836,19.0767239 4.81245604,20.3658821 C4.77756035,20.541359 4.76123447,20.733942 4.75436848,21.1375286 L4.753,21.201 L4.81891033,21.2072748 C5.17475407,21.238613 5.68824965,21.2483989 6.55477524,21.2498122 L6.8,21.25 L17.2,21.25 C18.2170845,21.25 18.7928988,21.2414619 19.1810982,21.2072743 L19.246,21.201 L19.2462331,21.1762143 C19.240389,20.788731 19.2266656,20.5889407 19.1977289,20.4209459 L19.1875098,20.3659114 C18.9310881,19.0767345 17.9232655,18.0689119 16.6340085,17.8124743 C16.3995984,17.7658228 16.1655866,17.7529795 15.3746802,17.7504977 Z M17.6758209,2.75094873 L6.32418466,2.75094873 C4.77009452,2.75789221 4.3498311,2.80604261 3.97852098,2.99523586 C3.55515405,3.21095057 3.21095057,3.55515405 2.99523395,3.97852472 C2.80604244,4.34983143 2.75789219,4.77009455 2.75094872,6.32418466 L2.75094872,17.6758209 C2.75789167,19.2299251 2.80603964,19.6501526 2.9952383,20.0215138 C3.0491636,20.1273508 3.11111915,20.228239 3.18034028,20.3234112 L3.285,20.455 L3.28943216,20.4106024 C3.29907542,20.3209638 3.31098429,20.2385405 3.32565826,20.1560533 L3.34127244,20.0732752 C3.71608904,18.1890389 5.18907057,16.7160809 7.07324489,16.3413264 C7.430501,16.2702247 7.70017946,16.2536292 8.58237437,16.2505913 L15.4176294,16.2505913 C16.2998336,16.253629 16.5695211,16.270223 16.9267114,16.3413098 C18.8109345,16.7160881 20.2839119,18.1890655 20.6586765,20.0732197 C20.6807809,20.1842963 20.6976679,20.2908708 20.7105263,20.4102716 L20.714,20.455 L20.8196502,20.3234241 C20.854256,20.2758386 20.8870472,20.2268229 20.9179274,20.1764732 L21.0047394,20.0215182 C21.2119773,19.6147744 21.25,19.1494319 21.25,17.2 L21.25,6.8 C21.25,4.85059543 21.2119738,4.38520437 21.0047346,3.97850218 C20.7890296,3.55512485 20.4448617,3.21093948 20.0215348,2.99524897 C19.6501544,2.80604057 19.2299253,2.75789175 17.6758209,2.75094873 Z M12,4.75 C14.6233262,4.75 16.75,6.87665909 16.75,9.5 C16.75,12.1233136 14.6233136,14.25 12,14.25 C9.37665909,14.25 7.25,12.1233262 7.25,9.5 C7.25,6.87664644 9.37664644,4.75 12,4.75 Z M12,6.25 C10.2050736,6.25 8.75,7.70507356 8.75,9.5 C8.75,11.2949014 10.2050885,12.75 12,12.75 C13.7948864,12.75 15.25,11.2948864 15.25,9.5 C15.25,7.70508854 13.7949014,6.25 12,6.25 Z"/>';
            downloadsHtml += '</svg>';
            downloadsHtml += 'Download official photo';
            downloadsHtml += '</a>';
        }

        if (bioDownload) {
            downloadsHtml += '<a href="' + bioDownload + '" download class="button button--light">';
            downloadsHtml += '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">';
            downloadsHtml += '<path d="M14,1.25 C14.1989124,1.25 14.3896778,1.32901763 14.5303301,1.46966991 L20.5303301,7.46966991 C20.6709824,7.6103222 20.75,7.80108763 20.75,8 L20.75,17.2 C20.75,19.4509681 20.7062776,19.986066 20.3412679,20.7024674 C19.9817594,21.4081091 19.4081091,21.9817594 18.7024818,22.3412606 C17.986066,22.7062776 17.4509681,22.75 15.2,22.75 L8.8,22.75 C6.54900457,22.75 6.01388313,22.7062762 5.29755782,22.3412654 C4.59192118,21.9817531 4.01824321,21.4081043 3.65871103,20.7024652 C3.29371942,19.9860556 3.25,19.4509614 3.25,17.2 L3.25,6.8 C3.25,4.54901128 3.29372079,4.01389353 3.65872414,3.29753902 C4.01824943,2.59192595 4.59192595,2.01824943 5.29753528,1.65872605 C6.01389353,1.29372079 6.54901128,1.25 8.8,1.25 L14,1.25 Z M13.25,2.75 L8.32418466,2.75094879 C6.77009452,2.75789221 6.3498311,2.80604261 5.97852098,2.99523586 C5.55515405,3.21095057 5.21095057,3.55515405 4.99523395,3.97852472 C4.80604244,4.34983143 4.75789219,4.77009455 4.75094872,6.32418466 L4.75094872,17.6758209 C4.75789167,19.2299251 4.80603964,19.6501526 4.9952383,20.0215138 C5.21093948,20.4448617 5.55512485,20.7890296 5.97854125,21.0047545 C6.38520437,21.2119738 6.85059543,21.25 8.8,21.25 L15.2,21.25 C17.1494319,21.25 17.6147744,21.2119773 18.0215326,21.0047321 C18.4448909,20.7890406 18.7890406,20.4448909 19.0047394,20.0215182 C19.2119773,19.6147744 19.25,19.1494319 19.25,17.2 L19.25,8.75 L15.6,8.75007 C14.8145586,8.75007 14.5823692,8.73603604 14.2823266,8.5968274 L14.2055429,8.55935312 C13.8762473,8.39159082 13.6086069,8.12390509 13.4407545,7.79457125 C13.2664739,7.45254953 13.25,7.25093075 13.25,6.40007 L13.25,2.75 Z M16,16.25 C16.4142136,16.25 16.75,16.5857864 16.75,17 C16.75,17.4142136 16.4142136,17.75 16,17.75 L8,17.75 C7.58578644,17.75 7.25,17.4142136 7.25,17 C7.25,16.5857864 7.58578644,16.25 8,16.25 L16,16.25 Z M16,12.25 C16.4142136,12.25 16.75,12.5857864 16.75,13 C16.75,13.4142136 16.4142136,13.75 16,13.75 L8,13.75 C7.58578644,13.75 7.25,13.4142136 7.25,13 C7.25,12.5857864 7.58578644,12.25 8,12.25 L16,12.25 Z M10,8.25 C10.4142136,8.25 10.75,8.58578644 10.75,9 C10.75,9.41421356 10.4142136,9.75 10,9.75 L8,9.75 C7.58578644,9.75 7.25,9.41421356 7.25,9 C7.25,8.58578644 7.58578644,8.25 8,8.25 L10,8.25 Z M18.189,7.25 L14.75,3.811 L14.7502633,6.53976117 C14.7518319,6.92922227 14.7603031,7.05861744 14.7728761,7.10198185 L14.7772151,7.11348906 C14.8012493,7.16064523 14.8394629,7.19886533 14.8864991,7.22282827 C14.9188168,7.23929535 15.0506948,7.25007 15.6,7.25007 L18.189,7.25 Z"/>';
            downloadsHtml += '</svg>';
            downloadsHtml += 'Download bio (PDF)';
            downloadsHtml += '</a>';
        }

        $sidebar.find('.leadership-sidebar__downloads').html(downloadsHtml);

        // Open sidebar
        openSidebar();
    });

    // Close bio sidebar
    $(document).on('click', '.js-close-bio', function(e) {
        e.preventDefault();
        closeSidebar();
    });

    // Close on ESC key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $sidebar.hasClass('is-open')) {
            closeSidebar();
        }
    });

    // Focus trap
    $(document).on('keydown', function(e) {
        if (!$sidebar.hasClass('is-open')) return;

        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        }
    });

    function openSidebar() {
        $sidebar.addClass('is-open');
        $sidebar.attr('aria-hidden', 'false');
        $body.addClass('is-modal');

        // Set up focus trap
        setTimeout(function() {
            focusableElements = $sidebar.find('button, a[href]').filter(':visible');
            firstFocusable = focusableElements.first()[0];
            lastFocusable = focusableElements.last()[0];

            // Focus close button for keyboard users only
            if (document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
                $sidebar.find('.leadership-sidebar__close').focus();
            }
        }, 50);
    }

    function closeSidebar() {
        $sidebar.removeClass('is-open');
        $sidebar.attr('aria-hidden', 'true');
        $body.removeClass('is-modal');

        // Return focus for keyboard users only
        if (previouslyFocused && document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
            previouslyFocused.focus();
        }
    }
});
